<div
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-at="modal-field"
>
  <div class="modal__content">
    <div class="modal__content__header">
      <div class="navbar navbar--sub">
        <div class="navbar__section navbar__section--title">
          {{ data.title | translate }}
        </div>
        <div class="navbar__section navbar__section--right">
          <gk-help-menu [isSmallIcon]="true" class="tw-mt-2"></gk-help-menu>
          <gk-icon-button icon="close" (buttonClick)="close()"></gk-icon-button>
        </div>
      </div>
    </div>
    <div class="modal__content__body">
      <gk-add-field-form
        *ngIf="fieldDetails"
        (saveForm)="saveField()"
        [fieldDetails]="fieldDetails"
        [farmList]="farmList"
        [holdingList]="holdingList"
        [farmHoldingList]="farmHoldingList"
        [(addAnother)]="addAnother"
        (addAnotherChanged)="addAnother = $event"
      >
      </gk-add-field-form>
    </div>
  </div>
</div>
